/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './Language';
import type { TranslationGroupType } from './TranslationGroupType';
import {
    TranslationGroupTypeFromJSON,
    TranslationGroupTypeFromJSONTyped,
    TranslationGroupTypeToJSON,
    TranslationGroupTypeToJSONTyped,
} from './TranslationGroupType';

/**
 * 
 * @export
 * @interface TranslationUpdateRequest
 */
export interface TranslationUpdateRequest {
    /**
     * 
     * @type {Language}
     * @memberof TranslationUpdateRequest
     */
    languageId?: Language;
    /**
     * 
     * @type {TranslationGroupType}
     * @memberof TranslationUpdateRequest
     */
    groupType?: TranslationGroupType;
    /**
     * 
     * @type {any}
     * @memberof TranslationUpdateRequest
     */
    groupKey?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationUpdateRequest
     */
    text?: string | null;
}



/**
 * Check if a given object implements the TranslationUpdateRequest interface.
 */
export function instanceOfTranslationUpdateRequest(value: object): value is TranslationUpdateRequest {
    return true;
}

export function TranslationUpdateRequestFromJSON(json: any): TranslationUpdateRequest {
    return TranslationUpdateRequestFromJSONTyped(json, false);
}

export function TranslationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'languageId': json['languageId'] == null ? undefined : LanguageFromJSON(json['languageId']),
        'groupType': json['groupType'] == null ? undefined : TranslationGroupTypeFromJSON(json['groupType']),
        'groupKey': json['groupKey'] === undefined ? undefined : json['groupKey'] === null ? null : json['groupKey'],
        'text': json['text'] === undefined ? undefined : json['text'] === null ? null : json['text'],
    };
}

export function TranslationUpdateRequestToJSON(json: any): TranslationUpdateRequest {
    return TranslationUpdateRequestToJSONTyped(json, false);
}

export function TranslationUpdateRequestToJSONTyped(value?: TranslationUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'languageId': LanguageToJSON(value['languageId']),
        'groupType': TranslationGroupTypeToJSON(value['groupType']),
        'groupKey': value['groupKey'],
        'text': value['text'],
    };
}

